export const PAYMENT = {
    CREDIT_CARD: 'CreditCard',
    DIRECT_DEBIT: 'DirectDebit',
};

export function resetFocusDonorSection(): void {
    const section = document.querySelector('.donor-detail-block');
    const isSectionExists = typeof section !== 'undefined' && section !== null;

    if (isSectionExists) {
        section.scrollIntoView({ behavior: 'smooth' });
    }
}
